import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[kui-side-panel-span]',
    standalone: false
})
export class KuiSidePanelSpanDirective {
  @HostBinding('class.ml-auto') leftMarginAuto = true;
}
